// components/FormBuilder/ComponentTypes/Text/index.tsx

import React from 'react';
import { Card, Input, Space, Button } from 'antd';
import { DeleteOutlined, UpOutlined, PlusOutlined, DragOutlined } from '@ant-design/icons';
import { SortableHandle } from 'react-sortable-hoc';
import { Select } from 'antd';
import { Checkbox } from 'antd';
import { Typography } from 'antd';

const DragHandle = SortableHandle(() => <DragOutlined style={{ cursor: 'move' }} size={18} />);

export const RadioButtonsGroup = ({ component, onChange, onDelete }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    return (
        <Card
            size="small"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    {/* Short Answer */}
                    <Typography.Paragraph>Single Choice</Typography.Paragraph>
                    <Typography.Paragraph disabled type="secondary">
                        (Selection)
                    </Typography.Paragraph>
                </Space>
            }
            extra={
                <Space direction="horizontal">
                    <Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />
                </Space>
            }
        >
            {!collapsed && (
                <Space direction="vertical" style={{ width: '100%' }} size={'middle'}>
                    <Input
                        style={{
                            width: '100%',
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                        showCount
                        maxLength={30}
                        size="small"
                        value={component.label}
                        onChange={(e) => onChange({ ...component, label: e.target.value })}
                        placeholder="Label"
                        required
                    />
                    <Typography.Text strong>Options</Typography.Text>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        {component['data-source']?.map((option, index) => (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                }}
                                key={`radio-option-${index}`}
                            >
                                <Input
                                    style={{
                                        width: '100%',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                    }}
                                    showCount
                                    maxLength={30}
                                    size="small"
                                    value={option.title}
                                    onChange={(e) => {
                                        const newOptions = [...component['data-source']];
                                        newOptions[index].title = e.target.value;
                                        newOptions[index].id = e.target.value;
                                        onChange({ ...component, 'data-source': newOptions });
                                    }}
                                    placeholder="Option"
                                    required
                                />
                                <Button
                                    disabled={component['data-source'].length === 2}
                                    icon={<DeleteOutlined />}
                                    onClick={() => {
                                        const newOptions = [...component['data-source']];
                                        newOptions.splice(index, 1);
                                        onChange({ ...component, 'data-source': newOptions });
                                    }}
                                    type="text"
                                    danger
                                />
                            </div>
                        ))}
                        <br />
                        <Button
                            type="dashed"
                            disabled={component['data-source'].length >= 10}
                            icon={<PlusOutlined />}
                            onClick={() => {
                                const newOptions = [...component['data-source']];
                                newOptions.push({
                                    // id: `${newOptions.length}_Option_${newOptions.length + 1}`,
                                    title: `Option ${newOptions.length + 1}`,
                                    id: `Option ${newOptions.length + 1}`,
                                });
                                onChange({ ...component, 'data-source': newOptions });
                            }}
                        >
                            Add Option
                        </Button>
                    </Space>
                    <Checkbox
                        checked={component.required}
                        onChange={(e) => onChange({ ...component, required: e.target.checked })}
                    >
                        Required
                    </Checkbox>
                </Space>
            )}
        </Card>
    );
};

export const CheckboxGroup = ({ component, onChange, onDelete }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    return (
        <Card
            size="small"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    <Typography.Paragraph>Multiple Choice</Typography.Paragraph>
                    <Typography.Paragraph disabled type="secondary">
                        (Selection)
                    </Typography.Paragraph>
                </Space>
            }
            extra={
                <Space direction="horizontal">
                    <Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />
                </Space>
            }
        >
            {!collapsed && (
                <Space direction="vertical" style={{ width: '100%' }} size={'middle'}>
                    <Input
                        style={{
                            width: '100%',
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                        showCount
                        maxLength={20}
                        size="small"
                        value={component.label}
                        onChange={(e) => onChange({ ...component, label: e.target.value })}
                        placeholder="Label"
                        required
                    />
                    <Typography.Text strong>Options</Typography.Text>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        {component['data-source']?.map((option, index) => (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                }}
                                key={`checkbox-option-${index}`}
                            >
                                <Input
                                    style={{
                                        width: '100%',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                    }}
                                    showCount
                                    maxLength={30}
                                    size="small"
                                    value={option.title}
                                    onChange={(e) => {
                                        const newOptions = [...component['data-source']];
                                        newOptions[index].title = e.target.value;
                                        newOptions[index].id = e.target.value;
                                        onChange({ ...component, 'data-source': newOptions });
                                    }}
                                    placeholder="Option"
                                    required
                                />
                                <Button
                                    disabled={component['data-source'].length === 1}
                                    icon={<DeleteOutlined />}
                                    onClick={() => {
                                        const newOptions = [...component['data-source']];
                                        newOptions.splice(index, 1);
                                        onChange({ ...component, 'data-source': newOptions });
                                    }}
                                    type="text"
                                    danger
                                />
                            </div>
                        ))}
                        <br />
                        <Button
                            type="dashed"
                            disabled={component['data-source'].length >= 10}
                            icon={<PlusOutlined />}
                            onClick={() => {
                                const newOptions = [...component['data-source']];
                                newOptions.push({
                                    title: `Option ${newOptions.length + 1}`,
                                    id: `Option ${newOptions.length + 1}`,
                                });
                                onChange({ ...component, 'data-source': newOptions });
                            }}
                        >
                            Add Option
                        </Button>
                    </Space>
                    <Checkbox
                        checked={component.required}
                        onChange={(e) => onChange({ ...component, required: e.target.checked })}
                    >
                        Required
                    </Checkbox>
                </Space>
            )}
        </Card>
    );
};
export const Dropdown = ({ component, onChange, onDelete }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    return (
        <Card
            size="small"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    <Typography.Paragraph>Dropdown</Typography.Paragraph>
                    <Typography.Paragraph disabled type="secondary">
                        (Selection)
                    </Typography.Paragraph>
                </Space>
            }
            extra={
                <Space direction="horizontal">
                    <Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />
                </Space>
            }
        >
            {!collapsed && (
                <Space direction="vertical" style={{ width: '100%' }} size={'middle'}>
                    <Input
                        style={{
                            width: '100%',
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                        showCount
                        maxLength={20}
                        size="small"
                        value={component.label}
                        onChange={(e) => onChange({ ...component, label: e.target.value })}
                        placeholder="Label"
                        required
                    />
                    <Typography.Text strong>Options</Typography.Text>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        {component['data-source']?.map((option, index) => (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                }}
                                key={`dropdown-opt-${index}`}
                            >
                                <Input
                                    style={{
                                        width: '100%',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                    }}
                                    showCount
                                    maxLength={30}
                                    size="small"
                                    value={option.title}
                                    onChange={(e) => {
                                        const newOptions = [...component['data-source']];
                                        newOptions[index].title = e.target.value;
                                        newOptions[index].id = e.target.value;
                                        onChange({ ...component, 'data-source': newOptions });
                                    }}
                                    placeholder="Option"
                                    required
                                />
                                <Button
                                    disabled={component['data-source'].length === 1}
                                    icon={<DeleteOutlined />}
                                    onClick={() => {
                                        const newOptions = [...component['data-source']];
                                        newOptions.splice(index, 1);
                                        onChange({ ...component, 'data-source': newOptions });
                                    }}
                                    type="text"
                                    danger
                                />
                            </div>
                        ))}
                        <br />
                        <Button
                            type="dashed"
                            disabled={component['data-source'].length >= 50}
                            icon={<PlusOutlined />}
                            onClick={() => {
                                const newOptions = [...component['data-source']];
                                newOptions.push({
                                    title: `Option ${newOptions.length + 1}`,
                                    id: `Option ${newOptions.length + 1}`,
                                });
                                onChange({ ...component, 'data-source': newOptions });
                            }}
                        >
                            Add Option
                        </Button>
                    </Space>
                    <Checkbox
                        checked={component.required}
                        onChange={(e) => onChange({ ...component, required: e.target.checked })}
                    >
                        Required
                    </Checkbox>
                </Space>
            )}
        </Card>
    );
};

export const OptIn = ({ component, onChange, onDelete }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    return (
        <Card
            size="small"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    <Typography.Paragraph>Opt In</Typography.Paragraph>
                    <Typography.Paragraph disabled type="secondary">
                        (Selection)
                    </Typography.Paragraph>
                </Space>
            }
            extra={
                <Space direction="horizontal">
                    <Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />
                </Space>
            }
        >
            {!collapsed && (
                <Space direction="vertical" style={{ width: '100%' }}>
                    <Input.TextArea
                        style={{
                            width: '100%',
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                        showCount
                        maxLength={300}
                        size="small"
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        value={component.label}
                        onChange={(e) => onChange({ ...component, label: e.target.value })}
                        placeholder="Label"
                        required
                    />
                    <Checkbox
                        checked={component.required}
                        onChange={(e) => onChange({ ...component, required: e.target.checked })}
                    >
                        Required
                    </Checkbox>
                </Space>
            )}
        </Card>
    );
};
